import { render, staticRenderFns } from "./NavOther.vue?vue&type=template&id=0a2bdeb8&scoped=true&"
import script from "./NavOther.vue?vue&type=script&lang=js&"
export * from "./NavOther.vue?vue&type=script&lang=js&"
import style0 from "./NavOther.vue?vue&type=style&index=0&id=0a2bdeb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bdeb8",
  null
  
)

export default component.exports